var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vars-editor',{model:{value:(_vm.modelVars),callback:function ($$v) {_vm.modelVars=$$v},expression:"modelVars"}})}
var staticRenderFns = []

export { render, staticRenderFns }